import React, { useEffect } from 'react';
import classes from './style.module.scss';
import Modal from '~/app/common/Modal';
import Header from './Header';
import Form from './Form';
import { useStoreActions, useStoreState } from '~/store';
import { ServiceDetails } from '~/types';

export interface CompleteServiceProps {
    open: boolean
    serviceDetails?: ServiceDetails
    onSave?: (id: ServiceDetails['id']) => void
    onClose: () => void
    isWorkOrderChecklist?: boolean
}

export type CompleteServiceComponent = React.FC<CompleteServiceProps>;

const CompleteService = ({ open, serviceDetails, onSave, onClose, isWorkOrderChecklist = false }) => {
    const costCategoryAction = useStoreActions(actions => actions.issue.fetchCostCategories);
    const fetchHPCodesAction = useStoreActions(actions => actions.issue.fetchHPCodes);
    const fetchWorkTypesAction = useStoreActions(actions => actions.issue.fetchWorkTypes);
    const netWorkStatus = useStoreState(state => state.app.offline.status);
    const hasSimplifiedWorkorder = useStoreState(state => state.service.hasSimplifiedWorkorder ?? false);

    useEffect(() => {
        if(!netWorkStatus && hasSimplifiedWorkorder) {
            serviceDetails?.departmentId && costCategoryAction(serviceDetails?.departmentId);
            fetchHPCodesAction();
            fetchWorkTypesAction();
        }
    }, [fetchHPCodesAction, fetchWorkTypesAction, hasSimplifiedWorkorder, netWorkStatus, serviceDetails?.departmentId, costCategoryAction]);
    
    return (
        <>
            <Modal className={classes['completeIssueModel']} open={open} onClose={onClose} position={'bottom'}>
                <Header />
                <Form onClose={onClose} serviceDetails={serviceDetails} onSave={onSave} isWorkOrderChecklist={isWorkOrderChecklist}/>
            </Modal>
        </>
    );
};

export default CompleteService;